module.exports = __webpack_public_path__ + "img/w18-b1.a449fabf.jpg";